let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eus4v")).then(() => parcelRequire('f59vQ'));